import { useNavigate } from 'react-router';
import { EmptyState } from '../ui';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <EmptyState
      icon="close"
      title="We can't find that page"
      body="The link may be old, or the app may have moved."
      ctaTitle="Go home"
      onCta={() => navigate('/')}
    />
  );
}
